/**
 * Created by sange on 15/08/2017.
 */

import { createEntityAdapter, EntityState } from '@ngrx/entity'

import * as membersActions from '../actions/members.actions'
import * as usersActions from '../actions/users.actions'
import * as fromTeam from '../actions/team.actions'

import { TeamMemberV1 } from '../../../../api/api/models/team-member-v1'

export interface State extends EntityState<TeamMemberV1> {
  loading: boolean,
}

export const adapter = createEntityAdapter<TeamMemberV1>({
  selectId: (teamMember: TeamMemberV1) => teamMember.id,
  sortComparer: false
})

export const initialState: State = adapter.getInitialState({
  loading: false
})

export function reducer(state = initialState,
                        action: usersActions.UsersActions | membersActions.MembersActions | fromTeam.TeamActions): State {
  switch (action.type) {

    case fromTeam.SELECT_TEAM_FOR_EDITING_FILLED: {
      const {editingTeamId, selectingTeamId} = action.payload
      return editingTeamId === selectingTeamId ? state : {...adapter.removeAll(state)}
    }

    case membersActions.LOAD_TEAM_MEMBERS: {
      return {
        ...adapter.removeAll(state),
        loading: true,
      } as State
    }

    case membersActions.LOAD_TEAM_MEMBERS_SUCCESS: {
      const {members} = action.payload
      if (!members) {
        return state
      }
      return {
        ...adapter.addAll(members, state),
        loading: false,
      } as State
    }

    case membersActions.LOAD_TEAM_MEMBER_SUCCESS: {
      const {member} = action.payload
      return {
        ...adapter.addOne(member, state),
        loading: false,
      } as State
    }

    case membersActions.DELETE_TEAM_MEMBER_SUCCESS: {
      return adapter.removeOne(action.payload.teamMemberId, state)
    }

    case membersActions.ADD_TEAM_MEMBER_SUCCESS: {
      return adapter.addOne(action.payload.teamMember, state)
    }

    case usersActions.UPDATE_USER_SUCCESS: {
      const {user} = action.payload
      const members = (state.ids as number[]).map(id => state.entities[id])
      const member = members.find(m => m.vendorUser.id === user.id)
      return {
        ...adapter.updateOne({
          id: member.id,
          changes: {
            ...member,
            vendorUser: {
              ...member.vendorUser,
              ...user
            }
          }
        }, state)
      } as State
    }

    default: {
      return state
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/team/store/reducers/members.reducer.ts